import axios from "axios";
import moment from "moment/moment";

const formatDate = (date) => moment(date).format('YYYY-MM-DD');

const dateParams = (fromDate, toDate) => ({
  fromDate: formatDate(fromDate),
  toDate: formatDate(toDate),
});

const reportingRequest = (url, fromDate, toDate) => axios.get(url, {
  params: dateParams(fromDate, toDate),
});

export const fetchVisitorStats = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/visitor-stats', fromDate, toDate);

export const fetchClicksAndImpressionsStats = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/clicks-and-impressions-stats', fromDate, toDate);

export const fetchBase = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/base', fromDate, toDate);

export const fetchClicksAndImpressions = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/clicks-and-impressions', fromDate, toDate);

export const fetchCountries = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/countries', fromDate, toDate);

export const fetchCities = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/cities', fromDate, toDate);

export const fetchSources = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/sources', fromDate, toDate);

export const fetchReferrers = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/referrers', fromDate, toDate);

export const fetchDevices = (fromDate, toDate) => reportingRequest('/ajax/v2/reporting/devices', fromDate, toDate);

export default {
  fetchVisitorStats,
  fetchClicksAndImpressionsStats,
  fetchBase,
  fetchClicksAndImpressions,
  fetchCountries,
  fetchCities,
  fetchSources,
  fetchReferrers,
  fetchDevices,
};